module.exports = __webpack_public_path__ + "static/media/loading_grey.441e6de5.svg";